import 'core-js/modules/es.array.join';
import 'core-js/modules/es.number.constructor';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.replace';
import { assert, assertType, assertRange } from 'yaassertion';
import { isWorldReadyInstance } from '@paypalcorp/worldready-core';
import '@paypalcorp/globalize/dist/globalize/number';

var Cldr = require('cldrjs/dist/cldr');
var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function globalizeToWorldReadyError(error) {
  if (error.code === "E_MISSING_CLDR") {
    return getMissingMetadataError(error.stack);
  }
  return new Error(["Oops, internal error", error.message, error.stack].join("\n"));
}
var log10 = Math.log(10);

/* https://stackoverflow.com/questions/22884720/what-is-the-fastest-way-to-count-the-number-of-significant-digits-of-a-number/22884878 */
function getSignificantDigitCount(n) {
  n = Math.abs(String(n).replace(".", "")); //remove decimal and make positive
  if (n == 0) return 0;
  while (n != 0 && n % 10 == 0) n /= 10; //kill the 0s at the end of n
  return Math.floor(Math.log(n) / log10) + 1; //get number of digits
}

/* https://www.jacklmoore.com/notes/rounding-in-javascript/ */
function round(value, decimals) {
  return decimals ? Number(Math.round(value + "e" + decimals) + "e-" + decimals) : value;
}
var ForeignExchangeFormat = /*#__PURE__*/function () {
  function ForeignExchangeFormat(worldReady, options) {
    var cldr = new Cldr("und");
    var fxMetadata = cldr.get("supplemental/foreignExchange");
    var validRegions = Object.keys(fxMetadata.regions);
    if (process.env.NODE_ENV !== "production") {
      assert(isWorldReadyInstance(worldReady), "WorldReady object missing.");
      assertType(options, "options", ["plain object"]);
      assertType(options.foreignExchangeRegion, "foreignExchangeRegion", ["string"]);
      assertRange(options.foreignExchangeRegion, validRegions, "Invalid foreignExchangeRegion");
      assertType(options.exchangeRate, "exchangeRate", ["number"]);
      assertType(options.fromCurrency, "fromCurrency", ["string"]);
      assertType(options.toCurrency, "toCurrency", ["string"]);
    }
    var exchangeRate = options.exchangeRate,
      foreignExchangeRegion = options.foreignExchangeRegion;
    var rulesKey = fxMetadata.regions[foreignExchangeRegion] || fxMetadata.regions["001"];
    var _fxMetadata$rules$rul = fxMetadata.rules[rulesKey],
      flippedFractionDigits = _fxMetadata$rules$rul.flippedFractionDigits,
      minimumFractionDigits = _fxMetadata$rules$rul.minimumFractionDigits,
      maximumFractionDigits = _fxMetadata$rules$rul.maximumFractionDigits,
      minimumSignificantDigits = _fxMetadata$rules$rul.minimumSignificantDigits,
      maximumSignificantDigits = _fxMetadata$rules$rul.maximumSignificantDigits;
    var flipped = false;
    var adjustedRate = exchangeRate;
    var formatterOptions = {};
    if (minimumFractionDigits && maximumFractionDigits) {
      /* Figure out # of sig figs if we round to nth decimal place */
      var sigFigs = getSignificantDigitCount(round(adjustedRate, maximumFractionDigits));

      /* Logic for flipping exchange rate */
      if (sigFigs < 2 && adjustedRate < 1) {
        adjustedRate = 1 / exchangeRate;
        /* Fraction digits may change after flip */
        minimumFractionDigits = flippedFractionDigits || minimumFractionDigits;
        maximumFractionDigits = flippedFractionDigits || maximumFractionDigits;
        flipped = true;
      }
      formatterOptions.minimumFractionDigits = minimumFractionDigits;
      formatterOptions.maximumFractionDigits = maximumFractionDigits;
    } else {
      /* Figure out # of sig figs if we round to 6th decimal place */
      var _sigFigs = getSignificantDigitCount(round(adjustedRate, 6));

      /* Logic for flipping exchange rate */
      if (_sigFigs < minimumSignificantDigits && adjustedRate < 1) {
        adjustedRate = 1 / exchangeRate;
        flipped = true;
      }
      formatterOptions.minimumSignificantDigits = minimumSignificantDigits;
      formatterOptions.maximumSignificantDigits = maximumSignificantDigits;
    }

    /* Set formatter */
    try {
      this.formatter = worldReady.globalize.numberFormatter(Object.assign({}, formatterOptions));
    } catch (error) {
      throw globalizeToWorldReadyError(error);
    }
    this.flipped = flipped;
    this.exchangeRate = adjustedRate;
    this.toCurrency = options.toCurrency;
    this.fromCurrency = options.fromCurrency;
  }
  var _proto = ForeignExchangeFormat.prototype;
  _proto.format = function format() {
    var formattedRate = this.formatter(this.exchangeRate);
    /* Adds characters for RTL directionality */
    return this.flipped ? "\u202A" + formattedRate + " " + this.fromCurrency + " = 1 " + this.toCurrency + "\u202C" : "\u202A1 " + this.fromCurrency + " = " + formattedRate + " " + this.toCurrency + "\u202C";
  };
  return ForeignExchangeFormat;
}();

export { ForeignExchangeFormat };
